export default "__VITE_ASSET__BuS$jI9l__"